<template>
  <DealTag v-if="firstDeal" :type="firstDeal.type" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import DealTag from '~/scopes/product-core/components/presentationals/DealTag/DealTag.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'

const { selectedOffer } = useFetchPickers()

const experiments = useExperiments()

const firstDeal = computed(() => {
  if (experiments['experiment.flashSalesOnPDP'] !== 'enabled') return null

  const deal = selectedOffer.value?.deals?.[0]
  if (deal?.type === 'flash_sales' || deal?.type === 'seller_flash_sales') {
    return deal
  }

  return null
})
</script>
